import React, { useState, useEffect } from 'react'
import {
	Input,
	Button,
	Modal,
	Form,
	Checkbox,
	InputNumber,
	Typography,
	Tooltip,
} from 'antd'
import PropTypes from 'prop-types'
import { AutoComplete } from 'antd'
import styled from 'styled-components'
import { QuestionCircleFilled } from '@ant-design/icons'
import FileUpload from '../../../components/fileUpload'
import { uploadContextFile } from '~/states/modules/question'
import { removeContextFile } from '~/states/modules/question'
import { uploadContextAiFile } from '~/states/modules/contextAi'
import { removeContextAiFile } from '~/states/modules/contextAi'
import { useDispatch } from 'react-redux'

const { Title } = Typography
const { Text } = Typography

const ContractModal = ({
	handleCreate,
	handleCreateLink,
	handleCancel,
	showModal,
	models,
	handleUploadedExternalFile,
}) => {
	const [form] = Form.useForm()
	const [selectedModel, setSelectedModel] = useState('')
	const [title, setTitle] = useState('')
	const [maxUses, setUses] = useState(0)
	const [options, setOptions] = useState(models)
	const [checked, setChecked] = useState(false)
	const [uploadExternalFile, setUploadExternalFile] = useState(null)
	const [iscontextFile, setIsContextFile] = useState(false)
	const [previousFileId, setPreviousFileId] = useState('')
	const dispatch = useDispatch()

	const onSearch = (searchText) =>
		setOptions(
			!searchText
				? models
				: models.filter((model) =>
						model.label.toLowerCase().includes(searchText.toLowerCase())
					)
		)

	const onSelected = (value, item) => {
		setSelectedModel(item)
	}

	useEffect(() => {
		setOptions(models)
	}, [models])

	useEffect(() => {
		if (selectedModel !== '') {
			if (selectedModel.contextAi !== true) {
				dispatch(removeContextAiFile())
			}
		}
	}, [dispatch, selectedModel])

	const handleFileChange = (files) => {
		if (files.length !== 0 && files[0].uid !== previousFileId) {
			setUploadExternalFile(files)
			handleUploadedExternalFile(files)
			setPreviousFileId(files[0].uid)

			// If the model requires context AI and is of type 'upload', use the same uploaded file as context
			if (
				selectedModel.contextAi === true &&
				selectedModel.text_type === 'upload'
			) {
				dispatch(uploadContextFile({ context: `${files[0].uid}.pdf` }))
				dispatch(
					uploadContextAiFile({
						context: `uploads/contexts/${files[0].uid}.pdf`,
					})
				)
				setIsContextFile(true)
			}
		}
	}

	const handleContextFileChange = (files) => {
		if (files.length === 0) {
			dispatch(removeContextFile())
			dispatch(removeContextAiFile())
			setIsContextFile(false)
		} else {
			if (files[0].uid !== previousFileId) {
				dispatch(uploadContextFile({ context: `${files[0].uid}.pdf` }))
				dispatch(
					uploadContextAiFile({
						context: `uploads/contexts/${files[0].uid}.pdf`,
					})
				)
				setIsContextFile(true)
				setPreviousFileId(files[0].uid)
			}
		}
	}

	const getFooterModal = () => (
		<div
			style={{
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'flex-end',
			}}>
			<Button key="cancelar" onClick={handleCancel}>
				Cancelar
			</Button>
			<Button
				style={{ marginLeft: 30 }}
				type="primary"
				key="criar"
				onClick={() =>
					checked
						? handleCreateLink({ title, modelId: selectedModel.id, maxUses })
						: handleCreate({ title, modelId: selectedModel.id })
				}
				form="newContractForm"
				disabled={
					!(
						selectedModel &&
						(title || selectedModel.autoTitle) &&
						!(
							selectedModel.text_type === 'upload' &&
							!uploadExternalFile &&
							!checked
						) &&
						!(selectedModel.contextAi === true && !iscontextFile)
					)
				}>
				Criar
			</Button>
		</div>
	)

	return (
		<StyledModal open={showModal} closable={false} destroyOnClose footer={null}>
			<Form form={form} id="newContractForm">
				<Title
					level={4}
					style={{
						color: 'rgba(0, 0, 0, 0.45)',
						textAlign: 'center',
						marginBottom: 0,
					}}>
					Novo Documento
				</Title>
				<NewDivider />
				<StyledItemForm label="Modelo" name="model">
					<AutoComplete
						options={options}
						placeholder="Selecione o modelo"
						onSelect={onSelected}
						onSearch={onSearch}
						style={{ width: '90%' }}
					/>
				</StyledItemForm>
				{selectedModel && (
					<>
						{!selectedModel.autoTitle && (
							<StyledItemForm label="Título" name="title">
								<Input
									style={{ width: '90%' }}
									autoFocus
									value={title}
									onChange={(e) => setTitle(e.target.value)}
								/>
							</StyledItemForm>
						)}
						<StyledItemForm>
							<Checkbox
								onChange={(e) => setChecked(e.target.checked)}
								checked={checked}>
								Criar URL externa
							</Checkbox>
						</StyledItemForm>
						<StyledItemForm
							label="Número de usos"
							name="uses"
							hidden={!checked}
							rules={[
								{
									type: 'number',
									min: 0,
									message: 'Número inválido!',
								},
							]}>
							<>
								<InputNumber
									autoFocus
									value={maxUses}
									min={0}
									onChange={(e) => setUses(e)}
								/>
								<Tooltip
									placement="top"
									title="Selecione 0 para a url não expirar">
									<QuestionCircleFilled style={{ marginLeft: '7px' }} />
								</Tooltip>
							</>
						</StyledItemForm>
						{selectedModel.text_type === 'upload' && !checked && (
							<StyledItemForm label="Upload Documento" name="Upload Documento">
								<FileUpload
									onChange={handleFileChange}
									metadata={{ extract_text: 'true' }}
									multiple={false}
									duplicateToContext={
										selectedModel.contextAi &&
										selectedModel.text_type === 'upload'
									}
								/>
								<Text
									type="secondary"
									style={{
										fontSize: '12px',
										display: 'block',
										marginTop: '8px',
									}}>
									* Apenas arquivos PDF de até 10MB são permitidos.
								</Text>
							</StyledItemForm>
						)}
						{selectedModel.contextAi === true &&
							selectedModel.text_type !== 'upload' && (
								<StyledItemForm
									label="Upload do Contexto"
									name="Upload do Contexto">
									<FileUpload
										onChange={handleContextFileChange}
										metadata={{ extract_text: 'true' }}
										folder={'contexts'}
										multiple={false}
									/>
									<Text
										type="secondary"
										style={{
											fontSize: '12px',
											display: 'block',
											marginTop: '8px',
										}}>
										* Apenas arquivos PDF de até 10MB são permitidos.
									</Text>
								</StyledItemForm>
							)}
					</>
				)}

				<NewDivider />
				{getFooterModal()}
			</Form>
		</StyledModal>
	)
}

ContractModal.propTypes = {
	handleCreate: PropTypes.func,
	handleCreateLink: PropTypes.func,
	handleCancel: PropTypes.func,
	handleNewContract: PropTypes.func,
	newContract: PropTypes.object,
	showModal: PropTypes.bool,
	models: PropTypes.array,
	handleUploadedExternalFile: PropTypes.func,
}

ContractModal.defaultProps = {
	models: [],
}

export default ContractModal

const StyledItemForm = styled(Form.Item)`
	.ant-form-item-label {
		padding: 0;
	}
`

const NewDivider = styled.div`
	background: rgba(0, 0, 0, 0.25);
	height: 0.8px;
	margin: 28px 0;
`

const StyledModal = styled(Modal)`
	.ant-modal-body {
		padding: 28px;
	}
`
